import { makeStyles } from "@material-ui/core";

export const CustomTooltipStyle = makeStyles(() => ({
  container: {
    position: "absolute",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    top: 20,
    height: "75%",
    right: "-12%",
  },
  triangle: {
    width: 0,
    height: 0,
    borderStyle: "solid",
    borderWidth: "15px 20px 15px 0",
    borderColor: "transparent #d9e7f0 transparent transparent",
  },
  tooltip: {
    width: "164px",
    background: "#d9e7f0",
    borderRadius: "8px",
    alignItems: "center",
    justifyContent: "center",
  },
  content: {
    fontFamily: "Lato",
    fontSize: "12px",
    color: "#235693",
    margin: "10px",
  },
}));
